import React from 'react';
import { CheckCircle, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { courses } from '../data/mockData';

const Courses = () => {
  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-green-50 via-white to-green-50 relative overflow-hidden">
      {/* Background Image - Subtle */}
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-5">
        <img 
          src="/images/academy/live-training.jpg" 
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-100 rounded-full mb-4">
            <TrendingUp className="h-4 w-4 text-green-700" />
            <span className="text-sm font-semibold text-green-700">Our Training Programs</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Courses <span className="text-green-600">Offered</span>
          </h2>
          <p className="text-lg text-gray-600">
            Comprehensive courses designed for beginners to advanced-level traders
          </p>
        </div>

        {/* Courses Grid */}
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8">
          {courses.map((course) => (
            <Card 
              key={course.id}
              className="border-2 border-green-200 hover:border-green-600 hover:shadow-2xl transition-all duration-300 bg-white"
            >
              <CardHeader>
                <CardTitle className="text-2xl text-gray-900 mb-2">
                  {course.title}
                </CardTitle>
                <CardDescription className="text-base text-gray-600">
                  {course.description}
                </CardDescription>
                <Badge className="w-fit mt-3 bg-green-100 text-green-700 hover:bg-green-200">
                  {course.suitable}
                </Badge>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  <h4 className="font-semibold text-gray-900 mb-3">What You'll Learn:</h4>
                  {course.topics.map((topic) => (
                    <div key={topic} className="flex items-start gap-3">
                      <CheckCircle className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">{topic}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="max-w-4xl mx-auto mt-12 text-center">
          <div className="bg-white border-2 border-green-600 rounded-xl p-6 shadow-lg">
            <p className="text-gray-700 text-lg">
              <span className="font-semibold text-green-700">Note:</span> Our courses focus on practical execution with 
              <span className="font-semibold"> live market examples</span>. We teach you how to apply concepts in real trading, 
              not just theory.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Courses;
